<template>
  <a-drawer placement="left" :closable="false" :visible="visible" @close="onClose">
    <img src="@/assets/logo.png" slot="title" height="22px" />
    <a-menu mode="inline" @click="handleClick">
      <a-menu-item key="/personal_center/guide">
        <span>Main Menu</span>
      </a-menu-item>
      <a-menu-item key="/personal_center/orderList">
        <span>Order</span>
      </a-menu-item>
      <a-sub-menu key="/designs" title="Designs">
        <a-menu-item key="/personal_center/producttemplate">Product Template</a-menu-item>
        <a-menu-item key="/personal_center/printfiles">Print Files</a-menu-item>
      </a-sub-menu>
      <a-menu-item key="/personal_center/stores">
        <span>Stores</span>
      </a-menu-item>
      <a-menu-item key="/personal_center/coupon">
        <span>Coupon</span>
      </a-menu-item>
      <a-menu-item key="/personal_center/billing">
        <span>Billing</span>
      </a-menu-item>
      <a-menu-item key="/systemNotice">
        <span>Notifications</span>
      </a-menu-item>
      <a-menu-item key="/affiliateProgram">
        <span>Affiliate Program</span>
      </a-menu-item>
      <a-sub-menu key="/setting" title="Setting">
        <a-menu-item key="/personal_center/accountdetails">Account Details</a-menu-item>
        <a-menu-item key="/personal_center/addressbook">Address Book</a-menu-item>
        <a-menu-item key="/personal_center/iossnumber">Ioss Number</a-menu-item>
      </a-sub-menu>
      <a-menu-item key="/home">
        <span>HomePage</span>
      </a-menu-item>
      <a-menu-item key="/products">
        <span>Product</span>
      </a-menu-item>
    </a-menu>
    <div class="btns">
      <a-button @click="conactUs"> Contact Us </a-button>
      <a-button @click="loginOut" style="background: #FFFFFF; color: #FFA200; border: 1px solid #FFA200;">
        Log Out
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { mapState } from 'vuex'
export default {
  name: 'Draw',
  props: ['visible', 'stockSkuCategoryList'],
  watch: {
    visible(val) {
      val && (document.querySelector('#app').style.overflow = 'hidden')
      !val && (document.querySelector('#app').style.overflow = 'auto')
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.info
    })
  },
  methods: {
    loginOut() {
      this.$ls.remove(ACCESS_TOKEN)
      window.location.reload()
    },
    conactUs() {
      window.ssq.push('chatOpen')
    },
    goProducts() {
      this.$router.push(`/products`)
      this.$emit('onclose')
    },
    handleClick(val) {
      const { keyPath, key } = val
      if (keyPath.includes('/affiliateProgram')) {
        const { has_application_form } = this.userInfo
        if (has_application_form === 1) {
          this.$router.push('/personal_center/apply')
        } else {
          this.$router.push('/personal_center/affiliateprogram')
        }
      } else {
        this.$router.push(key)
      }
      this.$emit('onclose')
    },
    onClose() {
      this.$emit('onclose')
    }
  }
}
</script>

<style lang="less" scoped>
.btns {
  margin-top: 20px;
  /deep/.ant-btn {
    width: 100%;
    margin-bottom: 12px;
    color: white;
    background: #ffa200;
  }
}
</style>
